import {MetodoAmostragem} from "./MetodoAmostragem";
import {Entidade} from "./Entidade";
import {Arquivo} from "./Arquivo";
import {Campanha} from "./Campanha";
import {Local} from "./Local";
import {Column, Entity, ManyToOne, OneToMany, PrimaryGeneratedColumn} from "typeorm";
import {JoinColumn} from "typeorm/browser";

@Entity("projeto")
export class Projeto  extends Entidade{
    @Column({nullable: false})
    nome?: string
    @Column({type: "date"})
    inicio?: Date
    @Column({type: "date"})
    fim?: Date
    @Column()
    obs?: string
    @ManyToOne(() => Local, {cascade: true} )
    @JoinColumn({name: "local_id"})
    local?: Local
    @OneToMany(() => MetodoAmostragem, (metodo) => metodo.projeto, {cascade: true})
    metodologias!: MetodoAmostragem[]
    @OneToMany(() => Campanha, (campanha) => campanha.projeto, {cascade: true})
    campanhas!: Campanha[]
    @OneToMany(() => Arquivo, (arquivo) => arquivo.projeto, {cascade: true})
    arquivos!: Arquivo[]
    @Column()
    agencia_sigla?: string

    grupos(): string {
        const siglas = this.metodologias?.flatMap(m => m.grupos)
        const unicos = [...new Set(siglas)]
        return unicos.join(' - ')
    }


  get metodosOrdenados(): MetodoAmostragem[]{
    return this.metodologias?.sort((a,b) => a.nome.localeCompare(b.nome)) ?? []
  }

}
